<span
  class="font-weight-bold fs-16 text-marine-blue-two"
  *scText="rendering.fields.addressSectionLabel"
></span>
<div class="line"></div>
<div class="row" [formGroup]="addressForm">
  <div class="col-xl-9 col-lg-11">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label *scText="formFields.fields.streetName.label"></label>
          <input
            type="text"
            class="form-control"
            [placeholder]="formFields.fields.streetName.placeholder"
            formControlName="streetName"
            maxlength="37"
            (blur)="onTouched()"
          />
          <span
            class="field-validation-error"
            *ngIf="streetName.errors?.required"
            >{{ formFields.genericErrors.required.message }}</span
          >
          <span
            class="field-validation-error"
            *ngIf="streetName.errors?.maxlength"
            >{{
              formFields.genericErrors.validationInvalidStreetNameLength.message
            }}</span
          >
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label *scText="formFields.fields.intNumber.label"></label>
          <input
            type="text"
            class="form-control"
            [placeholder]="formFields.fields.intNumber.placeholder"
            formControlName="houseNumber"
            maxlength="6"
            (blur)="onTouched()"
          />
          <span
            class="field-validation-error"
            *ngIf="houseNumber.errors?.maxlength"
            >{{
              formFields.genericErrors.validationInvalidHouseNumberLength
                .message
            }}</span
          >
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label *scText="formFields.fields.intCity.label"></label>
          <input
            type="text"
            class="form-control"
            [placeholder]="formFields.fields.intCity.placeholder"
            formControlName="city"
            maxlength="35"
            (blur)="onTouched()"
          />
          <span class="field-validation-error" *ngIf="city.errors?.required">{{
            formFields.genericErrors.required.message
          }}</span>
          <span class="field-validation-error" *ngIf="city.errors?.maxlength">{{
            formFields.genericErrors.validationInvalidCityLength.message
          }}</span>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label *scText="formFields.fields.zipCode.label"></label>
          <input
            type="text"
            class="form-control"
            [placeholder]="formFields.fields.zipCode.placeholder"
            formControlName="ZIPCode"
            maxlength="10"
            (blur)="onTouched()"
          />
          <span
            class="field-validation-error"
            *ngIf="ZIPCode.errors?.maxlength"
            >{{
              formFields.genericErrors.validationInvalidZIpCodeLength.message
            }}</span
          >
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 form-group">
        <!-- Country List -->
        <ab-country-list
          [rendering]="rendering"
          formControlName="country"
          class="form-control-custom"
        >
        </ab-country-list>
        <span class="field-validation-error" *ngIf="country.errors?.required">{{
          formFields.genericErrors.required.message
        }}</span>
      </div>
      <!-- Country List -->
      <div class="col-md-6 address-checkbox" *ngIf="showSaveAddressCheckbox">
        <div class="checkbox mb-3 mb-md-0">
          <div class="checkbox-wrapper large checkbox-transfer">
            <input
              formControlName="saveBeneficiaryAddress"
              type="checkbox"
              id="saveBeneficiaryAddress"
            />
            <label
              for="saveBeneficiaryAddress"
              *scText="formFields.fields.saveBeneficiaryAddress.label"
            ></label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
